// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__QeZM4","step":"styles_step__R3EWt","content":"styles_content__wZRTX","actions":"styles_actions__nsEiB","progress":"styles_progress__byfBc"};